export default __webpack_public_path__ + "static/media/icon_down.3da1b99e.svg";